'use client';
import { Typography } from '@monoimin/atoms';
import { SbRichTextLite } from '@monoimin/molecules/richtext/SbRichTextLite';

export function NotFoundIntro({
  heading,
  lead,
}: {
  heading?: string;
  lead?: any;
}) {
  if (!(heading || lead)) {
    return null;
  }

  return (
    <div data-testid='not-found-intro'>
      <Typography as='h1'>{heading}</Typography>
      <SbRichTextLite
        blok={lead}
        classNames={{ paragraph: 'subheading mt-8 lg:w-8/12' }}
      />
    </div>
  );
}
